import { View } from 'react-native';
import React from 'react';
import Button from '../Button';
import { twMerge } from 'tailwind-merge';

interface Props {
  buttonLabel?: string;
  backButtonLabel?: string;
  className?: string;
  disabled?: boolean;
  onSubmit: () => void;
  onBack?: () => void;
}

const Footer = ({
  buttonLabel,
  backButtonLabel,
  className,
  disabled = false,
  onSubmit,
  onBack,
}: Props) => {
  return (
    <View
      className={twMerge(
        'justify-end xl:flex flex-row flex-1 items-end',
        className
      )}
    >
      <View className="flex-row flex-1 items-center">
        {!!backButtonLabel && (
          <Button
            className="flex-1 mr-4"
            variant="tertiary"
            onPress={onBack}
            disabled={disabled}
          >
            {backButtonLabel}
          </Button>
        )}

        <Button disabled={disabled} className="flex-1" onPress={onSubmit}>
          {buttonLabel || 'CONTINUAR'}
        </Button>
      </View>
    </View>
  );
};

export default Footer;
